import * as React from "react";
import { useSelector } from "react-redux";
import { Button, Grid, Table, Loader } from "semantic-ui-react";

import { routeIdSelector as customerIdSelector } from "../../crud/customer/selectors";
import { routeIdSelector as employeeRecordIdSelector } from "../../crud/employeeRecord/selectors";
import { GPSpecialistInfo, GPSpecialistInfoListModel } from "../models";
import { generalPractitionerSpecialistApi } from "../gpSpecialistInfoApi";
import { ApplicationState } from "../../applicationState";

import { Create } from "./Create";

import { Link } from "redux-little-router";

export const AllGPSpecialistInfoRecords: React.FunctionComponent = () => {

    const path = useSelector((state: ApplicationState) => state.router.pathname);
    const customerId = useSelector(customerIdSelector);
    const employeeRecordId = useSelector(employeeRecordIdSelector);

    const [loading, setLoading] = React.useState<boolean>(true);
    const [infos, setInfos] = React.useState<GPSpecialistInfoListModel[]>([]);

    React.useEffect(() => {
        (async () => {
            setLoading(true);
            const records = await generalPractitionerSpecialistApi.getAll(customerId, employeeRecordId);
            setInfos(records);
            setLoading(false);
        })();
    }, [customerId, employeeRecordId]);

    const onNewGPSpecialistInfoCreated = React.useCallback((model: GPSpecialistInfo) => {
        setInfos([...infos, model]);
    }, [infos]);

    if (loading) {
        return <Loader />;
    }

    return (
        <>
            <Grid container className="nomargintop">
                <Grid.Row >
                    <Grid.Column width={6}>
                        <h1>GP/Specialist Info</h1>
                    </Grid.Column>
                    <Grid.Column width={10} textAlign="right">
                        <Button icon="add" content="Create" as={Link} href={`${path}/create`} />
                    </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                    <Grid.Column width={16}>
                        <Table>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell>Name</Table.HeaderCell>
                                    <Table.HeaderCell>Type</Table.HeaderCell>
                                    <Table.HeaderCell>Surgery</Table.HeaderCell>
                                    <Table.HeaderCell>Email</Table.HeaderCell>
                                    <Table.HeaderCell>Phone</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body>
                                {infos && infos.map(info => (
                                    <Table.Row key={info.id}>
                                        <Table.Cell>
                                            <Link href={`${path}/${info.id}`}>{info.name}</Link>
                                        </Table.Cell>
                                        <Table.Cell>{info.type}</Table.Cell>
                                        <Table.Cell>{info.surgeryName}</Table.Cell>
                                        <Table.Cell>{info.emailAddress}</Table.Cell>
                                        <Table.Cell>{info.telephoneNumber}</Table.Cell>
                                    </Table.Row>
                                ))}
                            </Table.Body>
                        </Table>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <Create onCreated={onNewGPSpecialistInfoCreated} />
        </>
    );
};
